import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { globalErrorHandler } from '../../../utils/GlobalErrorHandler'
import dayjs from "dayjs";
import { useNavigate, useParams } from 'react-router-dom';


const PaymentsPage = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    const { id } = useParams();
    const [guest, setGuest] = useState([]);
    const [selectedItemId, setSelectedItemId] = useState("");
    const [guestItems, setGuestItems] = useState([]); // array of added items
    const [discountItemIndex, setDiscountItemIndex] = useState(null);
    const [showItemDiscountModal, setShowItemDiscountModal] = useState(false);

    const [discountValue, setDiscountValue] = useState("");
    const [additionalItems, setAdditionalItems] = useState([]);
    const [monthlyRows, setMonthlyRows] = useState([]);
    const [monthlyDiscountModalIndex, setMonthlyDiscountModalIndex] = useState(null);
    const [monthlyDiscountValue, setMonthlyDiscountValue] = useState("");



    const getGuest = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-guest/${id}`, {
                withCredentials: true
            });

            const data = res.data?.guest || {};
            setGuest(data);

            let months = [];

            // create months array
            if (data.monthly_rents && data.monthly_rents.length) {

                months = data.monthly_rents.map(row => ({
                    month: dayjs(row.month.replace(/-00$/, "-01")).format("MMM YYYY"),
                    discount: parseFloat(row.discount || 0)
                }));
            } else {

                months = Array.from({ length: data.current_invoice_period || 1 }, (_, i) => ({
                    month: dayjs().add(i, 'month').format("MMM YYYY"),
                    discount: 0
                }));
            }
            setMonthlyRows(months);

            if (data.additional_items && data.additional_items.length) {
                const mappedItems = data.additional_items.map(ai => ({
                    id: ai.id,
                    name: ai.name,
                    description: ai.description,
                    rate: parseFloat(ai.rate),
                    discount: parseFloat(ai.discount || 0),
                }));
                setGuestItems(mappedItems);
            }
            else {
                setGuestItems([]);
            }

        } catch (err) {
            Swal.fire("Error", "Failed to load guest information", "error");
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        getGuest();
        getAdditionalItems();

    }, []);



    const getAdditionalItems = () => {
        setLoading(true);
        axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-additional-items`, {
            withCredentials: true
        })
            .then(res => {
                setAdditionalItems(res.data.additionalItems || []);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                globalErrorHandler(error, navigate);

            });
    };





    const handleAddItem = () => {
        const selected = additionalItems.find(ai => ai.id == selectedItemId);
        if (!selected) return;

        setGuestItems([...guestItems, {
            ...selected,
            discount: 0
        }]);
        setSelectedItemId("");
    };




    const openItemDiscountModal = (index) => {
        setDiscountItemIndex(index);
        setDiscountValue(guestItems[index].discount || "");
        setShowItemDiscountModal(true);
    };

    const applyItemDiscount = () => {
        const updated = [...guestItems];
        const item = updated[discountItemIndex];

        const discount = parseFloat(discountValue) || 0;

        if (discount >= item.rate) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Discount',
                text: 'Discount must be less than the item amount.',
            });
            return;
        }

        item.discount = discount;
        setGuestItems(updated);
        setShowItemDiscountModal(false);
    };



    const applyMonthlyDiscount = () => {
        const updated = [...monthlyRows];
        const row = updated[monthlyDiscountModalIndex];
        const discount = parseFloat(monthlyDiscountValue) || 0;

        console.log(guest);
        if (discount >= guest?.monthly_rate) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Discount',
                text: 'Discount must be less than the monthly amount.',
            });
            return;
        }

        row.discount = discount;
        setMonthlyRows(updated);
        setMonthlyDiscountModalIndex(null);
    };


    const handleSave = async () => {

        const { mode_of_payment } = guest;
        if (!mode_of_payment) {
            Swal.fire("Missing Fields", "Please enter mode of payment.", "warning");
            return;
        }

        const payload = {

            guest_id: guest?.id,
            monthly_rents: monthlyRows.map(row => ({
                month: row.month,                     // e.g. '2025-07-01'
                rate: parseFloat(guest?.monthly_rate || 0),
                discount: parseFloat(row.discount || 0),
            })),
            additional_items: guestItems.map(item => ({
                additional_item_id: item.id,
                rate: parseFloat(item.rate || 0),
                discount: parseFloat(item.discount || 0),
            })),
            mode_of_payment: guest?.mode_of_payment
        };

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_WEB_SERVICES_URL}/admin/save-guest-payment`,
                payload,
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: true,
                }
            );

            if (response.data.status) {
                // Swal.fire("Success", "Guest payment data saved.", "success");

                if (mode_of_payment === "online") {
                    navigate(`/admin/add-payment-online/${guest?.id}`);
                }
                else {


                    Swal.fire("Success", "Guest payment data saved.", "success");
                    navigate(`/admin/guest-management/guest`);


                }
            } else {
                Swal.fire("Error", response.data.message || "Failed to save data.", "error");
            }
        } catch (err) {
            console.error(err);
            Swal.fire("Error", "Something went wrong while saving.", "error");
        }



    };


    const handleInvoicePeriodChange = (e) => {
        const value = Number(e.target.value) || 0;

        // update guest state
        setGuest((prev) => ({ ...prev, current_invoice_period: value }));

        // create months array
        if (value > 0) {
            const months = Array.from({ length: value }, (_, i) => ({
                month: dayjs().add(i, "month").format("MMM YYYY"),
                discount: 0,
            }));
            setMonthlyRows(months);
        } else {
            setMonthlyRows([]); // reset if "Select" is chosen
        }
    };

    const getTotalSubtotal = () => {
        const baseRate = parseFloat(guest?.monthly_rate || 0);
        const rentSubtotal = monthlyRows.reduce((total, row) => total + baseRate, 0);
        const itemSubtotal = guestItems.reduce((total, item) => total + parseFloat(item.rate || 0), 0);
        return (rentSubtotal + itemSubtotal).toFixed(2);
    };

    const getTotalDiscount = () => {
        const rentDiscount = monthlyRows.reduce((total, row) => total + parseFloat(row.discount || 0), 0);
        const itemDiscount = guestItems.reduce((total, item) => total + parseFloat(item.discount || 0), 0);
        return (rentDiscount + itemDiscount).toFixed(2);
    };

    const getTotalAmountPaid = () => {
        const subtotal = parseFloat(getTotalSubtotal());
        const discount = parseFloat(getTotalDiscount());
        return (subtotal - discount).toFixed(2);
    };


    if (loading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }



    return (
        <div className="container-fluid px-4 mt-4 mb-5  " id="guest-main">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3 className="mb-0">Add Payment</h3>
            </div>


            <div className="row mb-4" >


                <div className="col-md-4 col-sm-6">
                    <label className="form-label">Invoice Period (Months)</label>
                    <select
                        className="form-select"
                        name="current_invoice_period"
                        value={guest.current_invoice_period}

                        onChange={handleInvoicePeriodChange}
                    >
                        <option value="" >Select</option>
                        {[...Array(36)].map((_, i) => (
                            <option key={i + 1} value={i + 1}  >
                                {i + 1} month{i > 0 ? "s" : ""}
                            </option>
                        ))}
                    </select>
                </div>


            </div>


            <div className="card shadow mt-4">
                <div className="card-header">
                    <h5 className="mb-0">Finalize and add Additional Items</h5>
                </div>
                <div className="card-body p-4">

                    <div className="row g-4">

                        <div className="col-lg-6 d-flex align-items-center fw-bold">
                            <i className="bi bi-house-door-fill me-2"></i> {guest?.property_name}, {guest?.floor_name}
                        </div>

                    </div>
                    <div className="row g-4 my-4 ">
                        <div className="col-lg-12">

                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <th>Bed</th>
                                        <th>Bed Type</th>
                                        <th>Month</th>
                                        <th>Rate</th>
                                        <th>Discount</th>
                                        <th>Subtotal</th>
                                    </tr>
                                    {monthlyRows.map((row, index) => (
                                        <tr key={index}>
                                            <td>{guest?.bed_id}</td>
                                            <td>{guest?.bedtypename}</td>
                                            <td>{row.month}</td>
                                            <td>${parseFloat(guest?.monthly_rate).toFixed(2)}</td>
                                            <td>
                                                {!row.discount ? (
                                                    <button className="btn btn-outline-success btn-sm" onClick={() => {
                                                        setMonthlyDiscountModalIndex(index);
                                                        setMonthlyDiscountValue("");
                                                    }}>
                                                        <i className="bi bi-plus-lg me-1"></i>Add Discount
                                                    </button>
                                                ) : (
                                                    <div className="d-flex align-items-center gap-2">
                                                        <span className="text-success fw-bold mb-0">${row.discount}</span>
                                                        <button
                                                            className="btn btn-sm btn-outline-danger py-0 px-2"
                                                            onClick={() => {
                                                                const updated = [...monthlyRows];
                                                                updated[index].discount = 0;
                                                                setMonthlyRows(updated);
                                                            }}
                                                        >
                                                            <i className="bi bi-x-lg"></i>
                                                        </button>
                                                    </div>
                                                )}
                                            </td>
                                            <td>${(parseFloat(guest?.monthly_rate) - (row.discount || 0)).toFixed(2)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                        </div>
                    </div>




                    <div className="row g-4">

                        <div className="col-lg-12 d-flex align-items-center fw-bold">
                            <i className="bi bi-plus-square me-2"></i> Additional Items
                        </div>

                    </div>
                    <div className="row g-4 my-4 ">
                        <div className="col-lg-12">

                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <th>Item</th>
                                        <th>Description</th>
                                        <th>Rate</th>
                                        <th>Discount</th>
                                        <th>Subtotal</th>
                                    </tr>
                                    {guestItems.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.name}</td>
                                            <td>{item.description}</td>
                                            <td>${parseFloat(item.rate).toFixed(2)}</td>
                                            <td>
                                                {!item.discount ? (
                                                    <button className="btn btn-outline-success btn-sm" onClick={() => openItemDiscountModal(index)}>
                                                        <i className="bi bi-plus-lg me-1"></i>Add Discount
                                                    </button>
                                                ) : (
                                                    <div className="d-flex align-items-center gap-2">
                                                        <span className="text-success fw-bold mb-0">${parseFloat(item.discount).toFixed(2)}</span>
                                                        <button className="btn btn-sm btn-outline-danger py-0 px-2" onClick={() => {
                                                            const updated = [...guestItems];
                                                            updated[index].discount = 0;
                                                            setGuestItems(updated);
                                                        }}>
                                                            <i className="bi bi-x-lg"></i>
                                                        </button>
                                                    </div>
                                                )}
                                            </td>
                                            <td>${(item.rate - (item.discount || 0)).toFixed(2)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                        </div>
                    </div>
                    <div className="row g-4">

                        <div className="col-lg-6 fw-bold gap-1">
                            <select className="form-select" name="additional_item_id" value={selectedItemId} onChange={(e) => setSelectedItemId(e.target.value)}  >
                                <option value="">--Additional Items--</option>
                                {additionalItems.map(ai => (
                                    <option key={ai.id} value={ai.id}>
                                        {ai.name} (${(ai.rate).toFixed(2)})
                                    </option>
                                ))}
                            </select>

                        </div>
                        <div className="col-lg-6  gap-2">
                            <button className="btn btn-dark" onClick={handleAddItem}>
                                <i className="bi bi-plus"></i> Add
                            </button>
                        </div>


                    </div>




                    <div className="row g-3 border-top border-bottom my-5">
                        <div className="col-md-6 border-end border-dark-subtle mt-0 py-4">

                            <h5 className="mb-3">Mode of Payment</h5>
                            <div className="d-flex flex-direction-row" >

                                <div className="form-check mb-3" onClick={(e) => setGuest(prev => ({ ...prev, mode_of_payment: 'online' }))}>
                                    <input className="form-check-input" type="radio" name="mode_of_payment" id="modeOfPaymentOnline" value="online" checked={guest?.mode_of_payment === "online"} />
                                    <label className=" form-check-label me-2" htmlFor="invoiceEmail">Online payment with credit card</label>
                                </div>
                                <div className="form-check" onClick={(e) => setGuest(prev => ({ ...prev, mode_of_payment: 'offline' }))} >
                                    <input className="form-check-input" type="radio" name="mode_of_payment" id="modeOfPaymentOffline" value="offline" checked={guest?.mode_of_payment === "offline"}
                                        onChange={(e) =>
                                            setGuest(prev => ({ ...prev, mode_of_payment: e.target.value }))
                                        }
                                    />
                                    <label className=" form-check-label" htmlFor="invoicePrinted">Pay at office with Cash or Check</label>

                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="px-2">
                                <div className="mb-3">
                                    <label className="form-label">Amount Paid:</label>
                                    <input
                                        type="text"
                                        name="amount_paid"
                                        className="form-control"
                                        disabled
                                        value={`$${Number(getTotalAmountPaid()).toFixed(2)}`}
                                    />
                                </div>

                                <div className="row mb-3">
                                    <div className="col">Subtotal:</div>
                                    <div className="col text-end">${getTotalSubtotal()}</div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col">Discount:</div>
                                    <div className="col text-end">${getTotalDiscount()}</div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col fw-bold">Total Amount Due:</div>
                                    <div className="col text-end">
                                        ${(getTotalSubtotal() - getTotalDiscount()).toFixed(2)}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>



                    <div className="d-flex flex-wrap gap-3 justify-content-center">

                        <button type="button" className="btn btn-lg btn-dark" onClick={handleSave}  >Save</button>

                    </div>
                </div>
            </div>



            {monthlyDiscountModalIndex !== null && (
                <div className="modal show d-block" tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Discount for {monthlyRows[monthlyDiscountModalIndex]?.month}</h5>
                                <button type="button" className="btn-close" onClick={() => setMonthlyDiscountModalIndex(null)}></button>
                            </div>
                            <div className="modal-body">
                                <input
                                    type="number"
                                    min={0}
                                    className="form-control"
                                    value={monthlyDiscountValue}
                                    onChange={(e) => setMonthlyDiscountValue(e.target.value)}
                                />
                                <small className="text-muted mt-1 d-block">
                                     This amount is in <strong>USD ($)</strong>.
                               </small>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setMonthlyDiscountModalIndex(null)}>Cancel</button>
                                <button className="btn btn-primary" onClick={applyMonthlyDiscount}>Apply</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}



            {showItemDiscountModal && (
                <div className="modal show d-block" tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Add Discount</h5>
                                <button type="button" className="btn-close" onClick={() => setShowItemDiscountModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <input
                                    type="number"
                                    min={0}
                                    className="form-control"
                                    value={discountValue}
                                    onChange={(e) => setDiscountValue(e.target.value)}
                                    placeholder="Enter discount"
                                />
                                <small className="text-muted mt-1 d-block">
                                     This amount is in <strong>USD ($)</strong>.
                               </small>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setShowItemDiscountModal(false)}>Cancel</button>
                                <button className="btn btn-primary" onClick={applyItemDiscount}>Apply</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


        </div>
    );
};

export default PaymentsPage;
